import React from 'react';
import renderHTML from 'react-render-html';
import classnames from 'classnames';

const parseLabel = (text) => {
  if (!text) return null;

  return renderHTML(text);
};

const Required = ({ isRequired }) => (isRequired ? (<span className="required">*</span>) : (null));

const Label = (props) => {
  const {
    label,
    className,
    htmlFor,
    required,
    children,
  } = props;

  if (!label) return null;

  return (
    <label htmlFor={htmlFor} className={classnames('form-label', className)}>
      {parseLabel(label)}
      <Required isRequired={required} />
      {children}
    </label>
  );
};

export default Label;
